import React, { Component } from 'react';
import * as _ from 'lodash';
import $ from 'jquery';
import { HashRouter, Route, Redirect } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import LinearProgress from 'material-ui/LinearProgress';
import classNames from 'classnames';

import './registration.scss';
import './registration-affiliations.scss';

import Header from './components/Header/Header';
import Nav from './components/Nav/Nav';
import Footer from './components/Footer/Footer';
import RegistrationStep1 from './components/registration-step1';
import RegistrationStep2 from './components/registration-step2';
import RegistrationStep3 from './components/registration-step3';
import RegistrationStep4 from './components/registration-step4';

import { RegistrationStore } from './registration.store';
import { RegistrationActions } from './registration.actions';
import { LoadingService } from '../services/loading.service';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import qs from 'query-string';

import getAffiliationAsync from './api/getAffiliationAsync';

export default class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...RegistrationStore.getState(),
      affiliation: null,
    };
    this.loadingService = new LoadingService();
  }

  async componentDidMount() {
    RegistrationStore.listen(this.onChange.bind(this));
    let search = qs.parse(window.location.search.replace('?', ''));

    if (search.id) {
      const { affiliation } = await getAffiliationAsync(search.id);
      this.setState({ affiliation });
    }

    if (search.message && search.message.length) {
      RegistrationActions.changeModalFromUrlStatus(true);
    }
  }

  componentWillUnmount() {
    RegistrationStore.unlisten(this.onChange.bind(this));
  }

  onChange(state) {
    this.setState(state);
  }

  goToStep(step) {
    this.props.history.push(
      _.trimEnd(this.props.match.url, '/') + '/step-' + step
    );
    // $("html, body").animate({ scrollTop: 0 }, 250);
  }

  formFieldChange(data) {
    return new Promise(resolve => {
      RegistrationActions.formFieldChange(data);
      resolve();
    });
  }

  affiliationsRender() {
    return (
      <div className="registration-affiliations">
        {this.renderModalWithMessageFromUrl()}
        <div
          className={classNames('loading-wrapper', {
            'loading-wrapper--on': this.state.isLoading,
          })}
        >
          {this.state.isLoading ? (
            <LinearProgress mode="indeterminate" style={{ height: 7 }} />
          ) : null}
        </div>

        <div className="container-fluid h-100">
          <Route
            exact
            path="/"
            render={() => {
              return <Redirect exact from="/" to="/step-1" />;
            }}
          />
          <Route
            path="/new-registration"
            render={() => {
              return <Redirect from="/new-registration" to="/step-1" />;
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-1'}
            render={props => {
              return (
                <RegistrationStep1
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-2'}
            render={props => {
              return (
                <RegistrationStep2
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-3'}
            render={props => {
              return (
                <RegistrationStep3
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-4'}
            render={props => {
              return (
                <RegistrationStep4
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
        </div>
        <NotificationContainer />
      </div>
    );
  }

  unaffiliatedRender() {
    return (
      <div className="registration">
        {this.renderModalWithMessageFromUrl()}
        <div
          className={classNames('loading-wrapper', {
            'loading-wrapper--on': this.state.isLoading,
          })}
        >
          {this.state.isLoading ? (
            <LinearProgress mode="indeterminate" style={{ height: 7 }} />
          ) : null}
        </div>

        <div className="container-fluid h-100">
          <Route
            exact
            path="/"
            render={() => {
              return <Redirect exact from="/" to="/step-1" />;
            }}
          />
          <Route
            path="/new-registration"
            render={() => {
              return <Redirect from="/new-registration" to="/step-1" />;
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-1'}
            render={props => {
              return (
                <RegistrationStep1
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-2'}
            render={props => {
              return (
                <RegistrationStep2
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-3'}
            render={props => {
              return (
                <RegistrationStep3
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
          <Route
            path={_.trimEnd(this.props.match.url, '/') + '/step-4'}
            render={props => {
              return (
                <RegistrationStep4
                  goToStep={stepNumber => this.goToStep(stepNumber)}
                  state={this.state}
                  onChange={this.formFieldChange.bind(this)}
                  {...props}
                />
              );
            }}
          />
        </div>
        <NotificationContainer />
      </div>
    );
  }

  renderModalWithMessageFromUrl() {
    let search = qs.parse(window.location.search.replace('?', ''));

    return (
      <Dialog
        title={
          <div>
            {search.title ? search.title : 'Houston, we have a problem...'}
            <a
              href="javascript:void(0);"
              className="close pull-right"
              onClick={() =>
                RegistrationActions.changeModalFromUrlStatus(false)
              }
            >
              &times;
            </a>
          </div>
        }
        actions={[
          <FlatButton
            label="OK"
            primary={true}
            onClick={() => RegistrationActions.changeModalFromUrlStatus(false)}
          />,
        ]}
        modal={true}
        open={this.state.isModalWithUrlMessageOpen}
      >
        <p>{search.message}</p>
      </Dialog>
    );
  }

  render() {
    const { affiliation } = this.state;

    if (affiliation) {
      return (
        <div className="BodyWrapper h-100">
          <Header
            logoUrl={affiliation.logo_url}
            logoHeight={affiliation.logo_height}
          />
          <Nav
            showLanguageButton={
              affiliation.registration_support_translation === 'true'
            }
            showFastpathLinks={affiliation.fastpath_enabled}
          />

          <main className="Main">{this.affiliationsRender()}</main>
          {!affiliation.registration_remove_footer && (
            <Footer
              footerLinks={affiliation.registration_footer_links}
              customFooterHtml={affiliation.custom_body_footer}
            />
          )}
        </div>
      );
    } else {
      return this.unaffiliatedRender();
    }
  }
}



// WEBPACK FOOTER //
// ./registration-react/Registration.js